<template lang="pug">
    v-app
        v-navigation-drawer(
            app
            dark
        )
            v-card-title(
                class="headline font-weight-black white--text"
                style="text-transform: uppercase"
            ) example.org

            v-divider.mt-2

            v-list(
                dense
                rounded
            )
                v-list-item(
                    v-for="(item, index) in nav"
                    :key="index"
                    link
                )
                    v-list-item-icon
                        v-icon {{ item.icon }}

                    v-list-item-content
                        v-list-item-title {{ item.title }}

        v-app-bar(
            id="app-bar"
            v-lightBackground
            app
            :elevation="elevation"
        )
            v-col(
                cols="12"
            )
                v-breadcrumbs(
                    :items="items"
                    class="white--text"
                )

        v-content(
            v-lightBackground
        )
            v-container(fluid)

            user

        v-footer(
            app
            dark
        )
    </v-app>
</template>

<style>
    div.nav-scrolled {
        box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.5) !important;
    }
</style>

<script lang="ts">
import Vue from "vue";
import HelloWorld from "./components/HelloWorld.vue";
import User from "./components/user-component/User.vue";

export default Vue.extend({
	name: "App",
	components: {
		HelloWorld,
		User
	},
	data: () => ({
		nav: [
			{ title: "Home", icon: "dashboard" },
			{ title: "About", icon: "question_answer" }
		],
		items: [
			{
				text: "Dashboard",
				disabled: false,
				href: "breadcrumbs_dashboard"
			},
			{
				text: "Link 1",
				disabled: false,
				href: "breadcrumbs_link_1"
			},
			{
				text: "Link 2",
				disabled: true,
				href: "breadcrumbs_link_2"
			}
		],
		divider: "/",
        dividers: ["/", "\\", ".", ";", ">", "-"],
        elevation: 0
	}),
	async mounted() {
		window.addEventListener("scroll", () => {           
            if (window.pageYOffset) {
                this.elevation = 4;
			} else {
                this.elevation = 0;
			}
		});
	},
	directives: {
		lightBackground: {
			inserted(el) {
				el.style.backgroundColor = "#f2f2f2";
			}
		}
	}
});
</script>
